import { ICommunity } from "../interfaces/community.interface";

export const concatCommunityAddress = (community?: ICommunity): string => {

    if (!community) {
      return '';
    }

    const addressParts = [
        community.addressLine1,
        community.addressLine2,
        community.city,
        community.state,
        community.zipCode
    ];
    return addressParts.filter(part => !!part && part.trim() !== '').join(', ');
  }

export function hasCommunitySubscriptionExpiredWithGrace(
  subscriptionEndDate?: string | Date | null
): boolean {
  if (!subscriptionEndDate) return true;

  const endDate = new Date(subscriptionEndDate);
  endDate.setDate(endDate.getDate() + 180);
  endDate.setHours(23, 59, 59, 999);
  const now = new Date();
  now.setHours(23, 59, 0, 0);

  return now > endDate;
}


 export function hasCommunitySubscriptionReachedEndDate(
   subscriptionEndDate?: string | Date | null,
   subscriptionStatusId?: number
 ): boolean {
    return subscriptionStatusId == 189;
 }
